import ApiService from "../service/ApiService";

const moduleName = "dda_category";

const ContractTemplateCategoryApi = {
  async list(query, loading) {
    let api = {
      module: moduleName,
      type: "list",
      value: query,
      dontLoading: loading === undefined ? false : loading,
    };
    return await ApiService(api);
  },

  async findById(id, loading) {
    let api = {
      module: moduleName,
      type: "findById",
      value: { id: id },
      dontLoading: loading === undefined ? false : loading,
    };
    return await ApiService(api);
  },
};

export default ContractTemplateCategoryApi;
